import { render, staticRenderFns } from "./StudentDashboard.vue?vue&type=template&id=62648ac6&scoped=true&"
import script from "./StudentDashboard.vue?vue&type=script&lang=js&"
export * from "./StudentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./StudentDashboard.vue?vue&type=style&index=0&id=62648ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62648ac6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VCard,VDialog,VDivider,VIcon,VProgressLinear})
